export default __webpack_public_path__ + "static/media/doctorShrug.7a7e72cb.png";